/**
 * Контракты персональной тренировки.
 */

import type {
  HintLevel,
  LanguageCode,
  LayoutId,
  MasteryStat,
  MasteryUnit,
  SessionDurationMinutes,
} from '@type2x/shared-contracts';
import type { Exercise } from '@type2x/exercise-generator';
import type { MemoryLoopState } from '@type2x/learning-engine';

/** Состояние навыка, из которого строится тренировка. */
export interface SkillSnapshot {
  readonly language: LanguageCode;
  readonly layoutId: LayoutId;
  readonly units: Readonly<Record<string, MasteryUnit>>;
  readonly stats: Readonly<Record<string, MasteryStat>>;
  readonly seenInControl: readonly string[];
  /** Доля нагрузки на левую руку за последние сессии, 0..1. */
  readonly leftHandShare: number;
}

/** Запрос на построение тренировки. */
export interface PracticeRequest {
  readonly snapshot: SkillSnapshot;
  readonly durationMinutes: SessionDurationMinutes;
  readonly seed: string;
  /** Момент построения в миллисекундах календарного времени. */
  readonly nowMs: number;
  readonly hintLevel: HintLevel;
  /** Наблюдаемое состояние пользователя по итогам прошлой сессии. */
  readonly accuracy: number;
  readonly fatigue: number;
  readonly effortlessSessions: number;
}

/** Готовая тренировка. */
export interface PracticePlan {
  readonly exercise: Exercise;
  /** Слова, для которых запускается Memory Loop. */
  readonly memoryLoop: readonly MemoryLoopState[];
  /** Почему смесь отличается от базовой. Пусто — смесь базовая. */
  readonly adaptationReasons: readonly string[];
  /** Единицы, обязательные к присутствию в упражнении. */
  readonly requiredUnitIds: readonly string[];
}

/** Сколько слов набирается в минуту начинающим — оценка объёма упражнения. */
export const ITEMS_PER_MINUTE = 12;

/** Сколько слов одновременно ведёт Memory Loop. */
export const MEMORY_LOOP_CAPACITY = 3;
